import { useAmplitude } from 'src/context/AmplitudeProvider';
import { EventNamesMap } from 'src/context/AmplitudeProvider';
import {
  LoginData,
  SignUpData,
} from 'src/features/auth/domain/AuthRepositoryInterface';
import { UserType } from 'src/types/common';

export default function useTrackAuthEvents() {
  const { logEvent } = useAmplitude();

  const trackLogin = ({ user }: LoginData) => {
    logEvent(EventNamesMap.SignIn, {
      email: user.email,
      phone: user.phone_number,
      name: user.first_name,
      last_name: user.last_name,
      user_id: user.pk,
      is_b2b: user.type === UserType.B2b,
      document_number: user.profile.document_number,
      document_type: user.profile.document_type,
    });
  };

  const trackRegister = ({ user }: SignUpData) => {
    logEvent(EventNamesMap.SignUp, {
      email: user.email,
      phone: user.phone_number,
      name: user.first_name,
      last_name: user.last_name,
      user_id: user.pk,
      is_b2b: user.type === UserType.B2b,
      document_number: user.profile.document_number,
      document_type: user.profile.document_type,
    });
  };

  const trackRegistrationFieldBlur = (
    fieldName: string,
    fieldValue: string | boolean | number
  ) => {
    logEvent(EventNamesMap.RegistrationFieldBlur, {
      field_name: fieldName,
      field_value: fieldValue,
    });
  };

  return {
    trackRegistrationFieldBlur,
    trackLogin,
    trackRegister,
  };
}
